import runwayLogoIcon from "./runwayLogoIcon.png";

// ==============================|| LOGO ICON IMAGE ||============================== //

export default function LogoIcon() {
  return (
    <img
      src={runwayLogoIcon}
      alt="Runway"
      style={{ display: "block", height: 32 }}
    />
  );
}
